import React from 'react'
// @ts-ignore
import DependencyItem from "./dependency-item"
// @ts-ignore
import DependenciesMoreItem from "./dependencies-more-item"
import EntityCollection from "../../../../model2/entities-collection/entities-collection";
import ModelEntity from "../../../../model2/model-entity";

type Props = {
    items       : EntityCollection

    className?  : string
}

export default class DependenciesInList extends React.Component<Props> {

    // static propTypes = {
    //     items: TasksCollection
    // }

    render() {

        // const items : Task[] = _.filter(this.props.items.models, task=>{
        //
        //     // patch why we here ?
        //     if (!task) {
        //         console.warn("#kdjhd039 missing item?")
        //         return false
        //     }
        //
        //
        //     // if (item.dependencyItemType)    return !['project', 'event'].includes(item.dependencyItemType)
        //     // else                            return ![ITEM_TYPE_PROJECT, ITEM_TYPE_EVENT].includes(item.type)
        // }) as Task[]

        // Sometimes not tasks (project events) items have no predecessors, succeessors
        // const items : Task[] = (this.props.items && this.props.items.models) ? this.props.items.allTasks : []
        const items : ModelEntity[] = (this.props.items && this.props.items.models) ? this.props.items.all : []

        const shownItems    = _.slice(items, 0 , 2)
        const hiddenItems   = _.slice(items, 2, items.length)

        return (
            <div className={Classes("dependencies-in-list", this.props.className)}>
                {_.map(shownItems, (entity)=>{

                    return <DependencyItem key={entity.rid} item={entity}/>

                })}
                <DependenciesMoreItem tasks={hiddenItems}/>
            </div>
        )
    }
}